import request from '../untils/request';

export const operationCommunityWhiteListApi = params => {
  return request({
    url: '/operation/community/white-list',
    authCode: 'GOODS_SETTING',
    params,
  });
};

export const operationCommunityChangeWhiteListApi = params => {
  return request({
    url: '/operation/community/change-white-list',
    authCode: 'GOODS_SETTING',
    params,
  });
};

export const getGoodsRankDown = params => {
  return request({
    url: '/goods/goods-basic/del-goods-to-array',
    params,
  });
};

export const goodsGetProvincesArea = params => {
  return request({
    url: '/goods/goods-basic/get-area',
    params,
  });
};

export const setNoDeliverAreas = params => {
  return request({
    url: '/goods/goods-basic/add-not-deliver-area',
    params,
  });
};

export const getNoDeliverAreas = params => {
  return request({
    url: '/goods/goods-basic/get-not-deliver-area',
    params,
  });
};

export const mergeNoDeliverAreas = params => {
  return request({
    url: '/goods/goods-basic/merge-not-deliver-area',
    params,
  });
};

export const getGoodsSpecialFreightList = params => {
  return request({
    url: '/system/goods-special-freight/list',
    params,
  });
};

export const setGoodsSpecialFreight = params => {
  return request({
    url: '/system/goods-special-freight/set-freight',
    params,
  });
};

export const deleteGoodsSpecialFreight = params => {
  return request({
    url: '/system/goods-special-freight/del-freight',
    params,
  });
};
